module.exports = __webpack_public_path__ + "img/Button.bc760a6e.png";